<div class="container-fluid" dir="rtl">
  <div *ngIf="isLoading" class="text-center my-5"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">در حال بارگذاری...</span></div><p class="mt-2">در حال بارگذاری صورت سبد سهام سرمایه‌گذاری...</p></div>
  <div *ngIf="error && !isLoading" class="alert alert-danger text-center" role="alert"><i class="fas fa-exclamation-triangle me-2"></i>{{ error }}<button type="button" class="btn btn-outline-danger btn-sm ms-3" (click)="goBack()">بازگشت</button></div>
  <div *ngIf="reportData && !isLoading" class="investment-portfolio-statement-detail">
    <div class="header-section card mb-4">
      <div class="card-header bg-warning text-dark"><h4 class="mb-0"><i class="fas fa-briefcase me-2"></i>جزئیات صورت سبد سهام سرمایه‌گذاری</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6"><p><strong>نماد:</strong> {{ reportData.symbol }} <span *ngIf="reportData.isin">({{ reportData.isin }})</span></p><p *ngIf="reportData.currency"><strong>واحد پول:</strong> {{ reportData.currency }}</p></div>
          <div class="col-md-6"><p><strong>سال مالی:</strong> {{ reportData.fiscalYear | persianNumber }}</p><p *ngIf="reportData.reportMonth"><strong>ماه گزارش:</strong> {{ reportData.reportMonth | persianNumber }}</p><p *ngIf="reportData.publishDate"><strong>تاریخ انتشار:</strong> {{ reportData.publishDate | jalali }}</p></div>
        </div>
        <div *ngIf="reportData.uri" class="mt-2"><a [href]="reportData.uri" target="_blank" class="btn btn-sm btn-outline-primary"><i class="fas fa-external-link-alt me-1"></i>مشاهده در سامانه کدال</a></div>
      </div>
    </div>

    <!-- 1) سبد سهام شرکت‌های پذیرفته‌شده در بورس -->
    <div class="section-card card mb-4" *ngIf="reportData.acceptedPortfolioItems?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-list me-2"></i>سبد سهام شرکت‌های پذیرفته‌شده در بورس</h5></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th>نام شرکت</th>
                <th>نماد</th>
                <th class="text-end">سرمایه</th>
                <th class="text-end">ارزش اسمی هر سهم</th>
                <th class="text-end">تعداد سهام ابتدای دوره</th>
                <th class="text-end">بهای تمام‌شده ابتدای دوره</th>
                <th class="text-end">ارزش بازار ابتدای دوره</th>
                <th class="text-end">تغییر تعداد سهام</th>
                <th class="text-end">تغییر بهای تمام‌شده</th>
                <th class="text-end">تغییر ارزش بازار</th>
                <th class="text-end">درصد مالکیت پایان دوره</th>
                <th class="text-end">بهای تمام‌شده پایان دوره</th>
                <th class="text-end">ارزش بازار پایان دوره</th>
                <th class="text-end">بهای هر سهم پایان دوره</th>
                <th class="text-end">ارزش هر سهم پایان دوره</th>
                <th class="text-end">سود/زیان</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.acceptedPortfolioItems">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companySymbol }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.capital))" tooltipClass="tooltip-class">{{ formatNumber(item.capital) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.shareNominalValue))" tooltipClass="tooltip-class">{{ formatNumber(item.shareNominalValue) }}</span></td>
                <td class="text-end">{{ formatNumber(item.startShareCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.startCost))" tooltipClass="tooltip-class">{{ formatNumber(item.startCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.startMarketValue))" tooltipClass="tooltip-class">{{ formatNumber(item.startMarketValue) }}</span></td>
                <td class="text-end">{{ formatNumber(item.shareCountChange) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.costChange))" tooltipClass="tooltip-class">{{ formatNumber(item.costChange) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.marketValueChange))" tooltipClass="tooltip-class">{{ formatNumber(item.marketValueChange) }}</span></td>
                <td class="text-end">{{ formatNumber(item.endOwnershipPercent) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endCost))" tooltipClass="tooltip-class">{{ formatNumber(item.endCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endMarketValue))" tooltipClass="tooltip-class">{{ formatNumber(item.endMarketValue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endCostPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.endCostPerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endValuePerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.endValuePerShare) }}</span></td>
                <td class="text-end" [class.text-success]="(item.profitLoss ?? 0) > 0" [class.text-danger]="(item.profitLoss ?? 0) < 0"><span [ngbTooltip]="convertToToman(formatNumber(item.profitLoss))" tooltipClass="tooltip-class">{{ formatNumber(item.profitLoss) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 2) سبد سهام شرکت‌های خارج از بورس -->
    <div class="section-card card mb-4" *ngIf="reportData.notAcceptedPortfolioItems?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-list me-2"></i>سبد سهام شرکت‌های خارج از بورس</h5></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th>نام شرکت</th>
                <th>نماد</th>
                <th class="text-end">سرمایه</th>
                <th class="text-end">ارزش اسمی هر سهم</th>
                <th class="text-end">تعداد سهام ابتدای دوره</th>
                <th class="text-end">بهای تمام‌شده ابتدای دوره</th>
                <th class="text-end">تغییر تعداد سهام</th>
                <th class="text-end">تغییر بهای تمام‌شده</th>
                <th class="text-end">درصد مالکیت پایان دوره</th>
                <th class="text-end">بهای تمام‌شده پایان دوره</th>
                <th class="text-end">بهای هر سهم پایان دوره</th>
                <th>وضعیت</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.notAcceptedPortfolioItems">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companySymbol }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.capital))" tooltipClass="tooltip-class">{{ formatNumber(item.capital) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.shareNominalValue))" tooltipClass="tooltip-class">{{ formatNumber(item.shareNominalValue) }}</span></td>
                <td class="text-end">{{ formatNumber(item.startShareCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.startCost))" tooltipClass="tooltip-class">{{ formatNumber(item.startCost) }}</span></td>
                <td class="text-end">{{ formatNumber(item.shareCountChange) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.costChange))" tooltipClass="tooltip-class">{{ formatNumber(item.costChange) }}</span></td>
                <td class="text-end">{{ formatNumber(item.endOwnershipPercent) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endCost))" tooltipClass="tooltip-class">{{ formatNumber(item.endCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.endCostPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.endCostPerShare) }}</span></td>
                <td>{{ item.statusDescription }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 3) خرید سهام طی دوره -->
    <div class="section-card card mb-4" *ngIf="reportData.incomeBuyItems?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-cart-plus me-2"></i>خرید سهام طی دوره</h5></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th>نام شرکت</th>
                <th>نماد</th>
                <th class="text-end">تعداد سهام</th>
                <th class="text-end">بهای هر سهم</th>
                <th class="text-end">بهای کل (پذیرفته‌شده)</th>
                <th class="text-end">بهای کل (خارج از بورس)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.incomeBuyItems">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companySymbol }}</td>
                <td class="text-end">{{ formatNumber(item.shareCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.costPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.costPerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedTotalCost))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedTotalCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.notAcceptedTotalCost))" tooltipClass="tooltip-class">{{ formatNumber(item.notAcceptedTotalCost) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 4) فروش سهام طی دوره -->
    <div class="section-card card mb-4" *ngIf="reportData.incomeSaleItems?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-cart-arrow-down me-2"></i>فروش سهام طی دوره</h5></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th>نام شرکت</th>
                <th>نماد</th>
                <th class="text-end">تعداد سهام</th>
                <th class="text-end">بهای هر سهم</th>
                <th class="text-end">بهای تمام‌شده</th>
                <th class="text-end">قیمت فروش هر سهم</th>
                <th class="text-end">مبلغ کل فروش</th>
                <th class="text-end">سود/زیان</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.incomeSaleItems">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companySymbol }}</td>
                <td class="text-end">{{ formatNumber(item.shareCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.costPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.costPerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.totalCost))" tooltipClass="tooltip-class">{{ formatNumber(item.totalCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.salePricePerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.salePricePerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.totalSaleAmount))" tooltipClass="tooltip-class">{{ formatNumber(item.totalSaleAmount) }}</span></td>
                <td class="text-end" [class.text-success]="(item.profitLoss ?? 0) > 0" [class.text-danger]="(item.profitLoss ?? 0) < 0"><span [ngbTooltip]="convertToToman(formatNumber(item.profitLoss))" tooltipClass="tooltip-class">{{ formatNumber(item.profitLoss) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 5) درآمد سود سهام محقق‌شده -->
    <div class="section-card card mb-4" *ngIf="reportData.dividendItems?.length || reportData.dividendDescription">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-coins me-2"></i>درآمد سود سهام محقق‌شده</h5></div>
      <div class="card-body">
        <div class="dividend-summary mb-3" *ngIf="reportData.dividendCurrentMonth != null || reportData.dividendYearEndToDate != null || reportData.dividendDescription">
          <div class="row">
            <div class="col-md-3" *ngIf="reportData.dividendCurrentMonth != null"><strong>سود ماه جاری:</strong> <span [ngbTooltip]="convertToToman(formatNumber(reportData.dividendCurrentMonth))" tooltipClass="tooltip-class">{{ formatNumber(reportData.dividendCurrentMonth) }}</span></div>
            <div class="col-md-3" *ngIf="reportData.dividendLastMonth != null"><strong>سود ماه قبل:</strong> <span [ngbTooltip]="convertToToman(formatNumber(reportData.dividendLastMonth))" tooltipClass="tooltip-class">{{ formatNumber(reportData.dividendLastMonth) }}</span></div>
            <div class="col-md-3" *ngIf="reportData.dividendYearEndToDate != null"><strong>سود از ابتدای سال:</strong> <span [ngbTooltip]="convertToToman(formatNumber(reportData.dividendYearEndToDate))" tooltipClass="tooltip-class">{{ formatNumber(reportData.dividendYearEndToDate) }}</span></div>
            <div class="col-md-3" *ngIf="reportData.dividendPastYearEndToDate != null"><strong>سود سال گذشته:</strong> <span [ngbTooltip]="convertToToman(formatNumber(reportData.dividendPastYearEndToDate))" tooltipClass="tooltip-class">{{ formatNumber(reportData.dividendPastYearEndToDate) }}</span></div>
          </div>
          <p class="mb-0 mt-2" *ngIf="reportData.dividendDescription"><strong>توضیحات:</strong> {{ reportData.dividendDescription }}</p>
        </div>
        <div class="table-responsive" *ngIf="reportData.dividendItems?.length">
          <table class="table table-striped table-hover table-sm" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th>نام شرکت</th>
                <th>سال مالی شرکت سرمایه‌پذیر</th>
                <th>تاریخ مجمع</th>
                <th class="text-end">تعداد سهام در تاریخ مجمع</th>
                <th class="text-end">سرمایه</th>
                <th class="text-end">ارزش اسمی هر سهم</th>
                <th class="text-end">درصد مالکیت</th>
                <th class="text-end">سود هر سهم</th>
                <th class="text-end">سود نقدی هر سهم</th>
                <th class="text-end">درآمد سود سال جاری</th>
                <th class="text-end">درآمد سود سال قبل</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.dividendItems">
                <td>{{ item.companyName }}</td>
                <td>{{ item.investeeCompanyFiscalYear }}</td>
                <td>{{ item.assemblyDate | jalali }}</td>
                <td class="text-end">{{ formatNumber(item.shareCountAtAssemblyDate) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.capital))" tooltipClass="tooltip-class">{{ formatNumber(item.capital) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.shareNominalValue))" tooltipClass="tooltip-class">{{ formatNumber(item.shareNominalValue) }}</span></td>
                <td class="text-end">{{ formatNumber(item.ownershipPercent) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.earningsPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.earningsPerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.cashEarningsPerShare))" tooltipClass="tooltip-class">{{ formatNumber(item.cashEarningsPerShare) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.currentYearDividendIncome))" tooltipClass="tooltip-class">{{ formatNumber(item.currentYearDividendIncome) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.priorYearDividendIncome))" tooltipClass="tooltip-class">{{ formatNumber(item.priorYearDividendIncome) }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 6) سرمایه‌گذاری به تفکیک گروه صنعت -->
    <div class="section-card card mb-4" *ngIf="reportData.industryGroupItems?.length">
      <div class="card-header bg-primary text-white"><h5 class="mb-0"><i class="fas fa-industry me-2"></i>سرمایه‌گذاری به تفکیک گروه صنعت</h5></div>
      <div class="card-body">
        <div *ngIf="reportData.reserveForInvestment != null || reportData.investmentDescription" class="mb-3">
          <div *ngIf="reportData.reserveForInvestment != null"><strong>ذخیره کاهش ارزش سرمایه‌گذاری:</strong> <span [ngbTooltip]="convertToToman(formatNumber(reportData.reserveForInvestment))" tooltipClass="tooltip-class">{{ formatNumber(reportData.reserveForInvestment) }}</span></div>
          <p class="mb-0" *ngIf="reportData.investmentDescription"><strong>توضیحات سرمایه‌گذاری:</strong> {{ reportData.investmentDescription }}</p>
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-sm text-nowrap" dir="rtl">
            <thead class="table-dark">
              <tr>
                <th rowspan="2">شرح گروه صنعت</th>
                <th colspan="6" class="text-center group-accepted">بورسی</th>
                <th colspan="4" class="text-center group-notaccepted">خارج از بورس</th>
                <th colspan="6" class="text-center group-total">جمع</th>
              </tr>
              <tr>
                <th class="text-end group-accepted">تعداد ابتدا</th>
                <th class="text-end group-accepted">بهای تمام‌شده ابتدا</th>
                <th class="text-end group-accepted">ارزش بازار ابتدا</th>
                <th class="text-end group-accepted">تغییر بهای تمام‌شده</th>
                <th class="text-end group-accepted">تغییر ارزش بازار</th>
                <th class="text-end group-accepted">بهای تمام‌شده پایان</th>
                <th class="text-end group-notaccepted">تعداد ابتدا</th>
                <th class="text-end group-notaccepted">بهای تمام‌شده ابتدا</th>
                <th class="text-end group-notaccepted">تغییر بهای تمام‌شده</th>
                <th class="text-end group-notaccepted">بهای تمام‌شده پایان</th>
                <th class="text-end group-total">تعداد ابتدا</th>
                <th class="text-end group-total">بهای تمام‌شده ابتدا</th>
                <th class="text-end group-total">درصد بهای ابتدا</th>
                <th class="text-end group-total">تغییر بهای تمام‌شده</th>
                <th class="text-end group-total">بهای تمام‌شده پایان</th>
                <th class="text-end group-total">درصد بهای پایان</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of reportData.industryGroupItems">
                <td>{{ item.description }}</td>
                <td class="text-end">{{ formatNumber(item.acceptedStartCompanyCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedStartCost))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedStartCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedStartMarketValue))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedStartMarketValue) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedCostChange))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedCostChange) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedMarketValueChange))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedMarketValueChange) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.acceptedEndCost))" tooltipClass="tooltip-class">{{ formatNumber(item.acceptedEndCost) }}</span></td>
                <td class="text-end">{{ formatNumber(item.notAcceptedStartCompanyCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.notAcceptedStartCost))" tooltipClass="tooltip-class">{{ formatNumber(item.notAcceptedStartCost) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.notAcceptedCostChange))" tooltipClass="tooltip-class">{{ formatNumber(item.notAcceptedCostChange) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.notAcceptedEndCost))" tooltipClass="tooltip-class">{{ formatNumber(item.notAcceptedEndCost) }}</span></td>
                <td class="text-end">{{ formatNumber(item.totalStartCompanyCount) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.totalStartCost))" tooltipClass="tooltip-class">{{ formatNumber(item.totalStartCost) }}</span></td>
                <td class="text-end">{{ formatNumber(item.totalStartCostPercent) }}</td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.totalCostChange))" tooltipClass="tooltip-class">{{ formatNumber(item.totalCostChange) }}</span></td>
                <td class="text-end"><span [ngbTooltip]="convertToToman(formatNumber(item.totalEndCost))" tooltipClass="tooltip-class">{{ formatNumber(item.totalEndCost) }}</span></td>
                <td class="text-end">{{ formatNumber(item.totalEndCostPercent) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-3 mb-4"><button type="button" class="btn btn-secondary" (click)="goBack()"><i class="fas fa-arrow-right me-2"></i>بازگشت به لیست</button></div>
  </div>
</div>
